<template>
    <div>
        <div>
            <div class="hero bg-light int-page">
                <TDSHead/>
            </div>
            <div v-if="loaded">
                <div class="container-fluid bg-light main-content">
                    <div class="container py-4 py-lg-8">
                        <div class="row">
                            <div class="col-12 text-center">
                                <h1 class="font-weight-bold text-primary m-0">{{$t('header.paths')}}</h1>
                            </div>
                            <div class="col-12 mb-3 text-center mt-3 mt-lg-6">
                                <div class="d-flex align-items-center justify-content-end">
                                    <div class="text-muted mr-4">{{$t('tracks.choose_year')}}</div>
                                    <div><b-form-select v-model="anno" :options="anni"  @change="updateSeries"></b-form-select></div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div role="tablist" class="accordion-wrapper">
                                    <b-card no-body class="accordion-wrapper--item" v-for="serie in data" :key="serie.ID">
                                        <b-card-header header-tag="header" class="p-0 border-0" role="tab">
                                            <div class="accordion-wrapper--item--header" href="#" v-b-toggle="'accordion-serie-'+serie.ID">
                                                <div class="d-lg-flex align-items-center w-100">
                                                    <div class="accordion-wrapper--item--header--media d-block d-lg-inline-block mx-auto mx-lg-0"><img :src="serie.ImageUrl" class="img-fluid rounded"></div>
                                                    <div class="accordion-wrapper--item--header--hgroup w-100 ml-lg-4 mt-3 mt-lg-0">
                                                        <div class="accordion-wrapper--item--header--hgroup-title">{{serie.Description}}</div>
                                                        <div class="accordion-wrapper--item--header--hgroup-subtitle" v-for="race in unique(serie.Races,'Location')" :key="race.ID">{{race.Location}}</div>
                                                    </div>
                                                </div>
                                                <div><img src="../assets/svg/more-icon.svg" height="20"></div>
                                                <!--<div class="d-block d-lg-none mt-3 btn btn-outline-secondary btn-sm">{{$t('event_organiser_detail.more')}}</div>-->
                                            </div>
                                        </b-card-header>
                                        <b-collapse class="accordion-wrapper--item--wrapper" :id="'accordion-serie-'+serie.ID" accordion="my-accordion" role="tabpanel">
                                            <b-card-body class="accordion-wrapper--item--wrapper--content">
                                                <div class="accordion-wrapper--item--wrapper--content--cta">
                                                    <a :href="serie.LinkUrl" target="_blank">{{$t('event_organiser_detail.go_to_website_of')}} {{serie.Description}}</a>
                                                </div>
                                                <div class="accordion-wrapper--item--wrapper--content--event" v-for="race in serie.Races" :key="race.ID">
                                                    <div class="accordion-wrapper--item--wrapper--content--event--content">
                                                        <div>
                                                            <div class="accordion-wrapper--item--wrapper--content--event--header">
                                                                <div class="accordion-wrapper--item--wrapper--content--event--header--hgroup">
                                                                    <div class="accordion-wrapper--item--wrapper--content--event--header--hgroup--eyebrow">{{race.DisciplineID | sport}}</div>
                                                                    <div class="accordion-wrapper--item--wrapper--content--event--header--hgroup--date">{{race.RaceDate|date}}</div>
                                                                    <div class="accordion-wrapper--item--wrapper--content--event--header--hgroup--title">{{race.Description}}</div>
                                                                    <div class="accordion-wrapper--item--wrapper--content--event--header--hgroup--subtitle">
                                                                        <div class="location"><span class="text">{{race.Location}}</span></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="race-item__services-panel--services-race-availables mt-3">
                                                                <Services :services="race.Services"></Services>
                                                            </div>
                                                        </div>
                                                        <div class="accordion-wrapper--item--wrapper--content--event----media">
                                                            <img :src="race.ImageUrl" class="accordion-wrapper--item--wrapper--content--event----media--image">
                                                        </div>
                                                    </div>
                                                    <div class="d-lg-flex align-items-center justify-content-between mt-3">
                                                        <div class="accordion-wrapper--item--body">
                                                            <div v-if="race.Organizer">{{$t('event_organiser_detail.title')}} <div class="d-block h6 font-weight-bold">{{race.Organizer}}</div></div>
                                                        </div>
                                                        <div class="text-right text-lg-left">
                                                            <router-link class="btn btn-outline-secondary btn-sm float-lg-right" :to="{ name: 'race', params: { id: race.ID }}" target="_blank">
                                                                {{$t('event_organiser_detail.go_to_race')}}
                                                            </router-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TDSFoot/>
    </div>
</template>

<script>
    import BaseVue from "./BaseVue"
    import sortedUniqBy from 'lodash/sortedUniqBy'
    import sortBy from 'lodash/sortBy'
    import Services from '../components/Services'

    export default {
        components: {Services},
        extends: BaseVue,
        name: 'circuiti',
        data() {
            return {
                data: [],
                anno: null,
                anni: [],
                loaded: false
            }
        },
        metaInfo() {
            return {
                title: ('Circuiti - TDS.sport'),
//                meta: [
//                    {
//                        name: 'description',
//                        content: 'content di prova'
//                    }
//                ]
            }
        },
        async mounted() {
            this.id = this.$route.params.id
            this.anno = (new Date()).getFullYear()
            this.anni = [
                {value: (this.anno-1),text: (this.anno-1)},
                {value: (this.anno),text: (this.anno)},
                {value: (this.anno+1),text: (this.anno+1)},
            ]
            this.updateSeries()

        }, computed: {

        }, methods: {
            async updateSeries() {
                let data = await this.get('series/' + this.anno, true)
                this.data = data.SeriesList
                this.loaded = true
            }, unique(data,field)
            {
                return sortedUniqBy(sortBy(data,field),field)
            }
        }
    }
</script>
